function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 16.472H5.414l9.566 9.484L13.026 28 0 15 13.026 2l1.954 2.044-9.566 9.484H30v2.944z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "2",
  width: "30",
  height: "26"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 16.472H5.414l9.566 9.484L13.026 28 0 15 13.026 2l1.954 2.044-9.566 9.484H30v2.944z",
  fill: "currentColor"
}))));